import { SkyscannerPriceinsightsV2PriceInsights } from '@skyscanner-internal/price-insights-web-http-client';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';

export const GRPC_PRICE_INSIGHTS_PRICE_BANDS_CLIENT_NAME = 'PRICE_INSIGHTS_SEARCH_PRICE_BANDS';
export const GRPC_PRICE_INSIGHTS_PRICE_BANDS_TIMEOUT = 10_000;

export const priceInsightsSearchPriceBandsRequest = grpcFetchClientWrapper(
  SkyscannerPriceinsightsV2PriceInsights.PriceInsightsService.SearchPriceBands,
  {
    clientName: GRPC_PRICE_INSIGHTS_PRICE_BANDS_CLIENT_NAME,
    pathPrefix: '/g/price-insights',
    timeoutMs: GRPC_PRICE_INSIGHTS_PRICE_BANDS_TIMEOUT,
  },
);
